import React, { ReactElement } from 'react';
import styled from 'styled-components/macro';
import Prompt from './Shared/Prompt';
import QuestionWrapper from './Shared/QuestionWrapper';

interface ITime {
  index: number;
  prompt: string;
  isRequired: boolean;
}

const Time = ({ index, prompt, isRequired }: ITime): ReactElement => {
  return (
    <QuestionWrapper index={index}>
      <Prompt prompt={prompt} isRequired={isRequired} />
      <br />
      <StyledInput type="time" />
    </QuestionWrapper>
  );
};

export default Time;

const StyledInput = styled.input`
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  box-sizing: border-box;
  font-size: 1em;

  border-radius: 7px;
  border: solid 1px #d2d2d2;
`;
